import { Component, Input, OnInit, inject } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { CstBelegartService } from "src/app/services/wawi/belegart.service";
import { MasterDataService } from "src/app/services/master-data.service";
import {
  AnlageWartungsHistoryDto,
  AnlageWartungsHistoryEntryDto,
  AnlageWartungsHistoryEntrySubType,
  AnlageWartungsHistoryEntryType,
  AnlageWartungsHistoryIncludes,
  TaskStatusMetaDto,
  TaskStatusMetaListDto,
  WartungsHistoryClientProvider,
  WawiBelegArt,
} from "src/app/web-api/web-api";
import {
  IFormDropDownItem,
} from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import { WartungshistoryExtendedFilterComponent } from "./wartungshistory-extended-filter/wartungshistory-extended-filter.component";
import { MatDialog } from "@angular/material/dialog";
import { WartungsHistoryExtendedFilterModel } from "./wartungshistory-extended-filter/wartungshistory-extended-filter.model";
import { finalize } from "rxjs/operators";
import { orderBy } from "src/app/helpers/cst-data-query";
import { CstConnectionService } from "src/app/services/cst-connection.service";
import { PermissionService } from "src/app/services/permission.service";
import { CstFileViewerService } from "src/app/common-components/file-viewers/services/file-viewer.service";
import { CstClarionService } from "src/app/services/clarion.service";
import { Router } from "@angular/router";

enum NoteDisplayLevelMobile {
  DontDisplay = "0",
  Display = "1",
}
enum NoteAcknowledged {
  Unread = "0",
  Acknowledged = "1",
}

@Component({
    selector: "wartungshistory-component",
    templateUrl: "./wartungshistory.component.html",
    styleUrls: ["./wartungshistory.component.scss"],
    standalone: false
})
export class WartungshistoryComponent implements OnInit {
  private _historyClient = inject(WartungsHistoryClientProvider);
  private _masterDataService = inject(MasterDataService);
  private _fb = inject(FormBuilder);
  private _perm = inject(PermissionService);
  private _connectionService = inject(CstConnectionService);
  private _fileViewerService = inject(CstFileViewerService);
  private _router = inject(Router);
  dialog = inject(MatDialog);
  belegArtService = inject(CstBelegartService);
  clarion = inject(CstClarionService);

  AnlageWartungsHistoryEntryType = AnlageWartungsHistoryEntryType;
  AnlageWartungsHistoryEntrySubType = AnlageWartungsHistoryEntrySubType;

  NOTE_DISPLAY_LEVEL_MOBILE = NoteDisplayLevelMobile;
  NOTE_ACK = NoteAcknowledged;

  private _facilityNoInternal = "";
  @Input() public set facilityNoInternal(value: string) {
    this._facilityNoInternal = value;
    this.refresh();
  }
  public get facilityNoInternal() {
    return this._facilityNoInternal;
  }

  public dataFromBackend: AnlageWartungsHistoryDto =
    new AnlageWartungsHistoryDto();
  public entryTypeFilterForm: FormGroup;
  public isLoading = false;

  public entryTypeFilters: Array<IFormDropDownItem> = [
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_None:All Entry Types`,
      value: AnlageWartungsHistoryEntryType.None,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Receipt:Receipts`,
      value: AnlageWartungsHistoryEntryType.Receipt,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Task:Tasks`,
      value: AnlageWartungsHistoryEntryType.Task,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Note:Notes`,
      value: AnlageWartungsHistoryEntryType.Note,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Document:Documents`,
      value: AnlageWartungsHistoryEntryType.Document,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Process:Processes`,
      value: AnlageWartungsHistoryEntryType.Process,
    },
  ];

  public taskStates: TaskStatusMetaListDto;
  public userHasAccessToPlanungAPI = false;
  public serviceHistoryFilter = new WartungsHistoryExtendedFilterModel();

  public filtersCombined = [];

  public status = "ONLINE";
  public isConnected = true;

  constructor() {
    this._connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected.hasInternetAccess;
      if (this.isConnected) {
        this.status = "ONLINE";
      } else {
        this.status = "OFFLINE";
      }
    });
  }

  public get displayFilter() {
    return this.filtersCombined?.length > 0;
  }

  ngOnInit(): void {
    this.userHasAccessToPlanungAPI = this._perm.UserCan_PlanungAPI;
    this.entryTypeFilterForm = this._fb.group({
      selectedFilter: [null],
    });
    this._masterDataService.Tasks.GetTaskStateMetas().subscribe({
      next: (result) => {
        this.taskStates = result;
      },
    });
  }

  public refresh() {
    this.fillTimeLine(AnlageWartungsHistoryEntryType.None);
  }

  public addHistoryEvent(event: AnlageWartungsHistoryEntryDto) {
    if (!this.dataFromBackend) {
      this.onSearchClick();
      return;
    }
    const newData = orderBy(
      [event, ...this.dataFromBackend.data],
      [{ field: "timestamp", dir: "desc" }]
    );
    const tmp = new AnlageWartungsHistoryDto();
    tmp.init({
      data: newData,
      total: this.dataFromBackend.total + 1,
      offset: this.dataFromBackend.offset,
      pageSize: this.dataFromBackend.offset,
    });
    setTimeout(() => (this.dataFromBackend = tmp), 250);
  }

  public fillTimeLine(e: AnlageWartungsHistoryEntryType): void {
    if (!this._facilityNoInternal) {
      return;
    }
    this.isLoading = true;
    this.dataFromBackend = null;
    const receiptTypeCSV =
      this.serviceHistoryFilter.receiptTypeFilter.join(",");
    this._historyClient
      .getWartungsHistory(
        this._facilityNoInternal,
        null,
        null,
        e,
        receiptTypeCSV,
        null,
        AnlageWartungsHistoryIncludes.RawData,
        this.serviceHistoryFilter.tasksShowDeleted
      )
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (result) => {
          if (result?.data?.length > 0) {
            let currentDateToCheck: Date = result.data[0].timestamp;
            for (let i = 1; i <= result.data.length - 1; i++) {
              if (
                currentDateToCheck.toDateString() !==
                result.data[i].timestamp.toDateString()
              ) {
                currentDateToCheck = result.data[i].timestamp;
              } else {
                result.data[i].timestamp = null;
              }
            }
          }
          this.dataFromBackend = result;
        },
      });
  }

  public createHistoryEntryTitleIcon(
    event: AnlageWartungsHistoryEntryDto
  ): string {
    let entryTitleIcon = "";
    switch (event.entryType) {
      case AnlageWartungsHistoryEntryType.Receipt:
        entryTitleIcon = "contract";
        break;
      case AnlageWartungsHistoryEntryType.Contract:
        entryTitleIcon = "receipt";
        break;
      case AnlageWartungsHistoryEntryType.Process:
        entryTitleIcon = "folder";
        break;
      case AnlageWartungsHistoryEntryType.Document:
        entryTitleIcon = "description";
        break;
      case AnlageWartungsHistoryEntryType.Note:
        entryTitleIcon = " ";
        break;
      default:
        return "";
    }
    return entryTitleIcon;
  }

  public createHistoryEntryTitle(event: AnlageWartungsHistoryEntryDto): string {
    let entryTitle = "";
    const entrySubType = event.entrySubType as number;
    switch (event.entryType) {
      case AnlageWartungsHistoryEntryType.Receipt:
        entryTitle =
          "Beleg - " +
          this.belegArtService.toString(entrySubType as WawiBelegArt);
        break;
      case AnlageWartungsHistoryEntryType.Task:
        entryTitle = "Aufgabe";
        if (event.rawData) {
          this.addEntrySubtypeTitle(
            event.entryType,
            event.entrySubType,
            event.rawData
          );
        }
        break;
      case AnlageWartungsHistoryEntryType.Note:
        break;
      case AnlageWartungsHistoryEntryType.Document:
        entryTitle =
          "Dokument - " +
          this.addEntrySubtypeTitle(event.entryType, event.entrySubType);
        break;
      case AnlageWartungsHistoryEntryType.Process:
        entryTitle = "Ordner";
        break;
      case AnlageWartungsHistoryEntryType.Contract:
        entryTitle = "Vertrag";
        break;
      default:
        return "";
    }
    return entryTitle + (entryTitle ? ":" : "");
  }

  public addEntrySubtypeTitle(
    entryType: number,
    entrySubType: number,
    rawData: any = null
  ): string {
    const documentSubtypes = ["", "Notiz", "Infoportal"];
    if (entryType === AnlageWartungsHistoryEntryType.Document) {
      return documentSubtypes[entrySubType];
    } else if (entryType === AnlageWartungsHistoryEntryType.Task) {
      return rawData.category ?? "";
    }
    return "";
  }
  
  public onNavigateReceipt(event: AnlageWartungsHistoryEntryDto) {
    window.location.href = `belsoft://receipts/view?receiptNo=${event.rawData.receiptNo}`;
  }

  private _getTaskMetaFromArray(taskState: number): TaskStatusMetaDto {
    for (const state of this.taskStates.statusMetaInfos) {
      if (state.state === taskState) {
        return state;
      }
    }
    return null;
  }

  public getTaskStateIcon(taskState: number): string {
    const state = this._getTaskMetaFromArray(taskState);
    return state?.symbol;
  }

  public getTaskStateIconColor(taskState: number): string {
    const state = this._getTaskMetaFromArray(taskState);
    return state?.color;
  }

  public getTaskStateIconToolTip(taskState: number): string {
    const state = this._getTaskMetaFromArray(taskState);
    return state?.displayLabel;
  }

  public getTaskStateLabel(taskState: number): string {
    const state = this._getTaskMetaFromArray(taskState);
    return state?.displayLabel;
  }

  public splitDateRange(dateRange: string, tokenNo: number): string {
    /*
    Task - rawData - dateRanges:
      Beispiel: 07.12.2020 - KW50/2020 - Dezember 2020
      Das sind von links nach rechts: Plantermin[tokenNo = 0], Eingeplant für KW[tokenNo = 1], zu erledigen in[tokenNo = 2]
    */
    const split = dateRange.split("-");
    if (split.length > tokenNo) {
      return split[tokenNo].trim();
    }
    return "";
  }

  public onExtendedFiltersClick(): void {
    const dialogRef = this.dialog.open(WartungshistoryExtendedFilterComponent, {
      data: this.serviceHistoryFilter,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== null && result !== undefined) {
        this.serviceHistoryFilter = result;
        this._refreshFiltersCombined();
        this.onSearchClick();
      }
    });
  }

  public onInfoportalDocumentOpen(documentID: string, name: string) {
    if (!documentID) {
      return;
    }
    this._fileViewerService.tryDisplayInfoportalDocument(
      documentID,
      name,
      true
    );
  }

  private _refreshFiltersCombined() {
    const result = [];
    if (
      this.serviceHistoryFilter &&
      this.serviceHistoryFilter.eventFilter !==
        AnlageWartungsHistoryEntryType.None
    ) {
      const label = this.entryTypeFilters.find(
        (x) => x.value === this.serviceHistoryFilter.eventFilter
      )?.label;
      if (label) {
        result.push({
          label,
          onRemove: (_) => {
            this.serviceHistoryFilter.eventFilter =
              AnlageWartungsHistoryEntryType.None;
            this._refreshFiltersCombined();
            this.onSearchClick();
          },
        });
      }
    }
    if (
      this.serviceHistoryFilter &&
      this.serviceHistoryFilter.receiptTypeFilter.length > 0
    ) {
      for (const recType of this.serviceHistoryFilter.receiptTypeFilter) {
        const label = this.belegArtService.toString(recType);
        if (label) {
          result.push({
            label,
            onRemove: (_) => {
              this.onReceiptTypeRemoved(recType);
              this._refreshFiltersCombined();
              this.onSearchClick();
            },
          });
        }
      }
    }
    this.filtersCombined = result;
  }

  onReceiptTypeRemoved(receiptType: number) {
    const receiptTypes = this.serviceHistoryFilter
      .receiptTypeFilter as number[];
    this.removeFirst(receiptTypes, receiptType);
    this.serviceHistoryFilter.receiptTypeFilter = receiptTypes;
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  public getLabelForEventType(eventType: number): string {
    for (const e of this.entryTypeFilters) {
      if (e.value === eventType) return e.label;
    }
    return "";
  }

  public onSearchClick(): void {
    if (this.serviceHistoryFilter.eventFilter === null) {
      this.serviceHistoryFilter.eventFilter =
        AnlageWartungsHistoryEntryType.None;
    }
    this.fillTimeLine(this.serviceHistoryFilter.eventFilter);
  }
}

/*
  Bescheibung der Datenobjekte aus den Entries der Historie siehe Redmine #14411 !
    Task - rawData - dueDate : Fälligkeitsdatum
*/
